import { getStateName } from "../../../../../../../shared/enums/usStates";
import Call from "../../../../../../../shared/svg/call-icon";
import LocationIcon from "../../../../../../../shared/svg/locationIcon";
import MedicalCard from "../../../../../../../shared/svg/medicalCardIcon";
import { HealthCareFacilityModel } from "../../../../../../data-model/healthFacility";
import DashboardTypeChip from "../dashboardTypeChip/dashboardTypeChip";

const HealthFacilityCard = (props: {
  healthCareData: HealthCareFacilityModel;
  isActive: boolean;
  showChip?: boolean;
}) => {
  return (
    <div
      className={
        props.isActive
          ? "hc-card__container active shadow-md"
          : "hc-card__container shadow-md"
      }
    >
      <div className="hc-card__hc-name flex items-center justify-between gap-2">
        <span>{props?.healthCareData.Name || "Unknown"}</span>
        {props.showChip && (
          <DashboardTypeChip
            dashboardType={props.healthCareData.dashboard_type}
          />
        )}
      </div>
      <div className="hc-card__other-details">
        <div className="hc-card__detail">
          <Call height="1rem" width="1rem" />
          {props?.healthCareData.PhoneNumber || "Unknown"}
        </div>
        <div className="hc-card__detail">
          <LocationIcon height="1rem" width="1rem" />
          {props?.healthCareData.Address?.State
            ? getStateName(props?.healthCareData.Address?.State)
            : "Unknown"}{" "}
          , USA
        </div>
        <div className="hc-card__detail">
          <MedicalCard height="1rem" width="1rem" />
          {props?.healthCareData.NPI || "Unknown"}
        </div>
      </div>
    </div>
  );
};

export default HealthFacilityCard;
